// Subscription plan editor for the main cart page.
// Uses Shopify's Cart API (remove + re-add) to change the selling plan
// when the customer selects a different frequency or switches to one-time.

(function () {
  'use strict';

  function getSectionsString() {
    return HELPER_UTIL.sectionRenderUtil('main-cart').getSectionsString();
  }

  function cartPost(endpoint, body) {
    return fetch(window.Shopify.routes.root + 'cart/' + endpoint + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw e; });
      return res.json();
    });
  }

  function reRenderCart() {
    var sections = getSectionsString();
    return fetch(window.Shopify.routes.root + 'cart/update.js?sections=' + sections, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        HELPER_UTIL.dispatchCustomEvent(
          _EVENT_HELPER.triggerCartChange,
          document,
          { sections: data.sections }
        );
      });
  }

  function setLoading(editor, loading) {
    editor.classList.toggle('subscription-editor--loading', loading);
    editor.querySelectorAll('input, select').forEach(function (el) {
      el.disabled = loading;
    });
  }

  function updateSubscription(editor, newSellingPlanId) {
    var lineKey = editor.dataset.lineKey;
    var variantId = Number(editor.dataset.variantId);
    var quantity = Number(editor.dataset.quantity);

    setLoading(editor, true);

    cartPost('change', { id: lineKey, quantity: 0 })
      .then(function () {
        var payload = { id: variantId, quantity: quantity };
        if (newSellingPlanId) {
          payload.selling_plan = Number(newSellingPlanId);
        }
        return cartPost('add', payload);
      })
      .then(function () {
        return reRenderCart();
      })
      .catch(function (err) {
        console.error('[SubscriptionEditor]', err);
        setLoading(editor, false);
      });
  }

  document.addEventListener('change', function (e) {
    var editor = e.target.closest('.cartItem__subscription-editor');
    if (!editor) return;

    if (e.target.classList.contains('subscription-editor__radio')) {
      var isSubscribe = e.target.value === 'subscribe';
      var frequencyRow = editor.querySelector('.subscription-editor__frequency');
      if (frequencyRow) frequencyRow.style.display = isSubscribe ? '' : 'none';

      if (isSubscribe) {
        var select = editor.querySelector('.subscription-editor__frequency-select');
        updateSubscription(editor, select ? select.value : null);
      } else {
        updateSubscription(editor, null);
      }
    } else if (e.target.classList.contains('subscription-editor__frequency-select')) {
      updateSubscription(editor, e.target.value);
    }
  });
})();
